<div class="modal-overlay">
    <div class="modal-body">
        <div class="modal-header">
            <span class="heading">Details</span>
            <button type="button" class="modal-close" (click)="toggleModal()" aria-label="Close details">
                <img src="../../../assets/close.svg" alt="" />
            </button>
        </div>
        <div class="info-container">
            <div class="info-row">
                <div class="info-label">Application Source</div>
                <div class="info-value">{{data.applicationSource}}</div>
            </div>
            <div class="info-row">
                <div class="info-label">Performed By</div>
                <div class="info-value">{{data.performedBy}}</div>
            </div>
            <div class="info-row" *ngIf="(data.eventDetails?.includes('Notification') || data.eventDetails === 'Notification Configuration Edited') && getTenantInfo()">
                <div class="info-label">Tenant Information</div>
                <div class="info-value">{{getTenantInfo()}}</div>
            </div>
            <div class="info-row" *ngIf="data.userType != ''">
                <div class="info-label">User Type</div>
                <div class="info-value">{{data.userType}}</div>
            </div>
            <div class="info-row">
                <div class="info-label">Timestamp</div>
                <div class="info-value">{{stringToDate(data.eventTime)}}</div>
            </div>
            <div class="info-row">
                <div class="info-label">Action</div>
                <div class="info-value">{{formattedAction}}</div>
            </div>
            <div class="info-row" *ngIf="data.eventDetails === 'Logsheet Edited'">
                <div class="info-label">Association</div>
                <div class="info-value">{{data.association ?? ''}}</div>
            </div>
            <div class="differences" *ngIf="data.prevStateObj && data.currentStateObj && auditSections.length > 0">
                <div class="changes-heading">Changes</div>
                <div class="changes-container">
                    <section class="audit-section" *ngFor="let section of auditSections">
                        <h3 class="audit-section__title">{{section.title}}</h3>
                        <div class="audit-group" *ngFor="let group of section.groups">
                            <div class="audit-group__header" *ngIf="group.title">
                                <h4 class="audit-group__title">
                                    <span class="audit-group__title-prefix" *ngIf="group.titlePrefix">{{group.titlePrefix}}: </span>{{group.title}}
                                </h4>
                                <span *ngIf="group.guardType"
                                    class="guard-type-badge"
                                    [class.guard-type-badge--advisory]="group.guardType === 'Advisory'"
                                    [class.guard-type-badge--acknowledge]="group.guardType === 'Acknowledged' || group.guardType === 'Acknowledge'">
                                    {{group.guardType}}
                                </span>
                                <span *ngIf="group.removed" class="guard-type-badge guard-type-badge--removed">
                                    Removed
                                </span>
                                <span *ngIf="group.added" class="guard-type-badge guard-type-badge--added">
                                    Added
                                </span>
                            </div>
                            <table class="change-table">
                                <thead>
                                    <tr>
                                        <th>Field</th>
                                        <th>Old State</th>
                                        <th>New State</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="table-row" *ngFor="let item of group.rows">
                                        <td>{{item.field}}</td>
                                        <td>{{item.oldValue}}</td>
                                        <td>{{item.newValue}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</div>
